<!-- 课程管理 添加 -->
<template>
  <div class="SchedulingDetailPreview form_box">
    <template v-if="studyClassName">
      <el-tag>{{studyClassName}}</el-tag>
    </template>
    <template v-if="dateinformation">
      <el-tag type="success">{{dateinformation}}{{timeinformation}}</el-tag>
    </template>
    <template v-if="address">
      <el-tag type="info">{{address}}</el-tag>
    </template>
    <template v-if="courses">
      <el-tag type="warning" v-for="item in courses" :key="item">{{item}}</el-tag>
    </template>
    <template v-if="showlevel">
      <el-tag type="danger">{{showlevel}}</el-tag>
    </template>
  </div>
</template>



<script>

export default {
  name: "schedulingDetailPreview",
  data() {
    return {
      studyClassName : "",
      dateinformation : "", // 日期信息
      timeinformation : "", // 时间信息
      address : "", //地址信息
      courses : [],
      showlevel : "",
    };
  },
  methods:{
    init(){

    },

    initStudyClass(data) {
      console.log("initStudyClass",data)
      this.studyClassName = data.scname;
    },

    initDateInformation(datetime, datetype) {
      let timetype = "";
      if (datetype == 0) {
        timetype = "上午";
      } else if (datetype == 1) {
        timetype = "下午";
      } else {
        timetype = "晚上";
      }
      this.dateinformation = datetime + " " + timetype;
    },

    initTimeInformation(starttime, endtime) {
      // 设置时间信息
    },

    initCourses(value) {
      this.courses = value;
    },

    initAddress(value) {
      this.address = value;
    },

    initShowLevel(value) {
      if (value == 0) {
        this.showlevel = "全部";
      } else if (value == 1) {
        this.showlevel = "单位等级";
      } else if (value == 2) {
        this.showlevel = "支部等级";
      } else if (value == 3) {
        this.showlevel = "个人等级";
      }
     }
  },
  watch:{
  },
  mounted(){
    this.init();
  },
  created() {

  },
};
</script>






<style scoped lang="scss">
.SchedulingDetailPreview {
  padding-left: 20px;

  > * {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>

